import { render } from "./ReleaseItem.vue?vue&type=template&id=3ea474fa"
import script from "./ReleaseItem.vue?vue&type=script&lang=js"
export * from "./ReleaseItem.vue?vue&type=script&lang=js"

import "./ReleaseItem.vue?vue&type=style&index=0&id=3ea474fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__